export default __webpack_public_path__ + "assets/ico_step_1-57db17fa.svg";